














































import User from '@/datatypes/user';
import EnterpriseService from '@/services/enterprise/EnterpriseService';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import Vue from 'vue';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default Vue.extend({
  data: () => ({
    administrators: new Array<User>(),
    hasNext: true,
    errorMessage: '',
    nextPointer: undefined as string | undefined,
    enterpriseService: new EnterpriseService(),
    removingAdministrator: {
      status: false,
      administrator: undefined,
    },
  }),

  components: {
    SnackbarMessageHandler,
  },

  mounted() {
    this.routeChanged();
  },

  watch: {
    $route() {
      this.routeChanged();
    },
  },

  methods: {
    routeChanged() {
      this.getAdministrators();
    },

    requestRemoval(administrator) {
      this.removingAdministrator = {
        status: true,
        administrator,
      };
    },

    cancelRemoval() {
      this.removingAdministrator = {
        status: false,
        administrator: undefined,
      };
    },

    confirmRemoval() {
      this.enterpriseService.deleteGlobalAdministrator(
        this.removingAdministrator.administrator,
      ).then(() => {
        this.$store.commit('errorMessage', 'Global administrator removal request sent.');
      }, (error) => {
        this.$store.commit('errorMessage', error.response.data.message);
      });
    },

    getAdministrators() {
      this.enterpriseService.getGlobalAdministrators().then((response) => {
        this.administrators = response.data.map((data) => new User(camelcaseKeysDeep(data)));
      });
    },
  },
});
